import type { GroupedReactionDto } from "@/modules/social/gateway/socialDto"
import type { ReactionSocialPostEntity } from "@/modules/social/entities/socialEntity"

type PostLike = {
  reactions: ReactionSocialPostEntity
  commentsNumber: number
}

export type SocialPostModel = {
  hasReactions: boolean
  totalReactions: number
  totalComments: number
  isEmpty: boolean
  displayedReactions: GroupedReactionDto[]
  currentUserEmoji: string | null
  hasCurrentUserReaction: boolean
}

export function createSocialPostModel(post: PostLike): SocialPostModel {
  const sortedReactions = [...post.reactions.allGroupedReactions].sort((a, b) => b.number - a.number)

  return {
    hasReactions: post.reactions.totalReactions > 0,
    totalReactions: post.reactions.totalReactions,
    totalComments: post.commentsNumber,
    isEmpty: post.reactions.totalReactions === 0 && post.commentsNumber === 0,
    displayedReactions: sortedReactions.slice(0, 3),
    currentUserEmoji: post.reactions.myReaction?.emoji ?? null,
    hasCurrentUserReaction: post.reactions.myReaction !== null,
  }
}
